import { renderInDocument } from '@spotahome/soyuz/client';

import LogIn from './main';

renderInDocument(LogIn);
